/** Pengalih bahasa. Bawaan `id`; pilihan disimpan di localStorage (`design/I18N.md` §0). */
import { useTranslation } from 'react-i18next';

import { LANGS, currentLang, setLang } from '../i18n';
import type { Lang } from '../i18n';

export function LanguageSwitcher() {
  const { t, i18n } = useTranslation();
  const aktif = (i18n.language === 'en' ? 'en' : 'id') as Lang;
  return (
    <label className="lang" aria-label={t('common.language')}>
      <span className="lang-teks">{t('common.language')}</span>
      <select
        data-testid="lang"
        value={aktif}
        onChange={(e) => setLang(e.target.value as Lang)}
      >
        {LANGS.map((l) => (
          <option key={l} value={l}>
            {l.toUpperCase()}
          </option>
        ))}
      </select>
    </label>
  );
}

export { currentLang };
